declare global {
  interface Window {
    bringwidgets?: {
      import: {
        render: (
          element: HTMLElement,
          config: {
            url: string
            language?: string
            theme?: string
            baseQuantity?: string
            requestedQuantity?: string
          }
        ) => void
      }
    }
  }
}

const BRING_SCRIPT_ID = 'bring-import-script'
let bringScriptPromise: Promise<void> | null = null

export const loadBringScript = (): Promise<void> => {
  if (typeof window === 'undefined') {
    return Promise.resolve()
  }

  if (window.bringwidgets?.import?.render) {
    return Promise.resolve()
  }

  if (bringScriptPromise) {
    return bringScriptPromise
  }

  bringScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(BRING_SCRIPT_ID) as HTMLScriptElement | null
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(), { once: true })
      existingScript.addEventListener('error', () => reject(new Error('Bring script kon niet worden geladen.')), {
        once: true,
      })
      return
    }

    const script = document.createElement('script')
    script.id = BRING_SCRIPT_ID
    script.async = true
    script.src = 'https://platform.getbring.com/widgets/import.js'
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Bring script kon niet worden geladen.'))
    document.body.appendChild(script)
  })

  return bringScriptPromise
}
